import { httpCreate, getUrlPath } from './http';
import conf from './config';
const uploadHost = conf.uploadHost;

const http = httpCreate('/shop/api/upload');
const uploadHttp = httpCreate('/upload', 600e3);

export const shopUpload = {
	/**
	 * 获取token
	 * @param { String } params.uploadType
	 * @param { Number } params.storeId
	 * @returns
	 */
	getToken(activityId, params) {
		return http.get('/token', { params });
	},
	// 上传图片
	img(data, token, config) {
		const backend = encodeURI(getUrlPath('/shop/api/upload/one'));
		return uploadHttp.post(`/file/image?backend=${backend}`, data, {
			...config,
			baseURL: uploadHost + '/upload',
			headers: {
				token: token,
			},
		});
	},
};
